module.exports = __webpack_public_path__ + "img/tip_cards_home.ae13db53.png";